import React, { ComponentProps } from 'react';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { asView } from '../../../_lib/ViewFetcher';
import { useBlockContext } from '../../../_lib/BlockFetcher';
import { TableOfContents } from '../partials/TableOfContents';

type TableOfContentsDefaultProps = {
  visible: boolean;
};

function TableOfContentsDefault({ visible }: TableOfContentsDefaultProps) {
  const { editModeInfo } = useAppContext();
  const { uuid } = useBlockContext();
  return <TableOfContents editModeActive={editModeInfo.active} visible={visible} uuid={uuid} />;
}

export const TableOfContentsDefaultView = asView(TableOfContentsDefault);
export type TableOfContentsDefaultView = ComponentProps<typeof TableOfContentsDefaultView>;
